import { useState } from 'react';

import { faCopy, faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import cx from 'classnames';

import ClickableIcon from '../../ClickableIcon';
import { Input } from '../../Input';
import { TInput } from '../../Input/Input';
import PasswordStrengthMeter from './components/PasswordStrengthMeter';
import VISIBILITY_TOGGLE_ID from './constants/visibilityToggleId';

import styles from './password-input.module.scss';

export default function PasswordInput({
  error,
  passwordStrengthMeter,
  copyEnabled,
  ...props
}: { validationError?: string; passwordStrengthMeter?: boolean; copyEnabled?: boolean } & TInput) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div>
      <Input
        InputLabelProps={{ shrink: true }}
        fullWidth
        label="Password"
        type={showPassword ? 'text' : 'password'}
        {...props}
        className={cx('mb-5', props.className)}
        InputProps={{
          endAdornment: !props.disabled ? (
            <div className={styles['password-input__adornment-container']}>
              <ClickableIcon
                id={VISIBILITY_TOGGLE_ID}
                icon={!showPassword ? faEye : faEyeSlash}
                withHover={false}
                onClick={() => setShowPassword(!showPassword)}
                className="ml-10"
              />
              {!copyEnabled && (
                <ClickableIcon
                  icon={faCopy}
                  spin={false}
                  asyncAction
                  onClick={async () => {
                    await navigator.clipboard.writeText((props.value as string) || '');
                  }}
                />
              )}
            </div>
          ) : null,
        }}
      />
      {!error && passwordStrengthMeter && (
        <>
          <PasswordStrengthMeter password={props.value as string} />
        </>
      )}
    </div>
  );
}
